module.exports = __webpack_public_path__ + "img/reset-password-desktop-fr.94e9c251.jpg";